import {ModulePolicy} from '../policies/modulePolicy';

export const useModulePolicy = (store, scopes) => new ModulePolicy(store.authStore.user, scopes);
